<template>
  <div :class="$style.wallet">
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>我的钱包</p>
    </header>
    <div :class="$style.redEnvelopeType" v-if="!withdrawStep">
      <div :class="$style.info">
        <div>
          <p :class="$style.account">用户账号: {{ user_name }}</p>
          <p>角色: {{ role.role_name }}</p>
        </div>
        <div>
          <p :class="$style.account">区服: {{ role.server_name }}</p>
          <p>总余额: {{ allBalance }}元</p>
        </div>
      </div>
      <ul :class="$style.typeList">
        <li v-if="levelBalance.show">
          <div>
            <img :src="`${$cdnLink}/red-envelope/icon_4.png`" alt="" />
            <div>
              <p :class="$style.typeName">等级红包</p>
              <p :class="$style.typeBalance">
                未提现<span>{{ (levelBalance.balance + levelBalance.flash_money).toFixed(2) }}</span
                >元
              </p>
            </div>
          </div>
          <button @click="selectWithdrawType(1)">选择提现类型</button>
        </li>
        <li v-if="payBalance.show">
          <div>
            <img :src="`${$cdnLink}/red-envelope/icon_7.png`" alt="" />
            <div>
              <p :class="$style.typeName">充值红包</p>
              <p :class="$style.typeBalance">
                未提现<span>{{ (payBalance.balance + payBalance.flash_money).toFixed(2) }}</span
                >元
              </p>
            </div>
          </div>
          <button @click="selectWithdrawType(2)">选择提现类型</button>
        </li>
        <li v-if="advancedBalance.show">
          <div>
            <img :src="`${$cdnLink}/red-envelope/icon_2.png`" alt="" />
            <div>
              <p :class="$style.typeName">高级红包</p>
              <p :class="$style.typeBalance">
                未提现<span>{{ (advancedBalance.balance + advancedBalance.flash_money).toFixed(2) }}</span
                >元
              </p>
            </div>
          </div>
          <button @click="selectWithdrawType(3)">选择提现类型</button>
        </li>
      </ul>
      <p :class="$style.record" @click="toRecord">
        <span>使用记录</span>
        <i :class="`iconfont yw-xiangyou `"></i>
      </p>
    </div>
    <!-- 选择提现类型 普通红包 闪电提现 -->
    <div :class="$style.selectMethods" v-if="withdrawStep == 1">
      <div :class="$style.info" v-if="receive_info.version == 1">
        <div>
          <p :class="$style.account">用户账号: {{ user_name }}</p>
          <p>角色: {{ role.role_name }}</p>
        </div>
        <div>
          <p :class="$style.account">区服: {{ role.server_name }}</p>
          <p v-if="receive_info.version == 2">总余额: {{ allBalance }}元</p>
        </div>
      </div>
      <div :class="$style.typeItem" v-if="receive_info.version == 1 || currentBalance.balanceShow">
        <img :src="`${$cdnLink}/red-envelope/icon_1.png`" alt="" />
        <div :class="$style.balance">
          <p>普通红包</p>
          <p>
            未提现<span>{{ balance }}</span
            >元
          </p>
        </div>
        <button :class="$style.withdraw" @click="selectWithdrawMethod(0)">立即提现</button>
      </div>
      <div :class="$style.typeItem" v-if="receive_info.version == 1 || currentBalance.flashMoneyShow">
        <img :src="`${$cdnLink}/red-envelope/icon_5.png`" alt="" />
        <div :class="$style.balance">
          <p>闪电提现</p>
          <p>
            未提现<span>{{ flash_money }}</span
            >元
          </p>
        </div>
        <button :class="$style.withdraw" @click="selectWithdrawMethod(1)">立即提现</button>
      </div>
      <p :class="$style.record" @click="toRecord" v-if="receive_info.version == 1">
        <span>使用记录</span>
        <i :class="`iconfont yw-xiangyou `"></i>
      </p>
    </div>
    <div :class="$style.balanceWithdraw" v-if="withdrawStep == 2">
      <div :class="$style.price">
        <h3>提现金额</h3>
        <div :class="$style.select">
          <div :class="$style.exhibition" @click="selected = !selected">
            <span>
              {{ withDrawAccount ? withDrawAccount.label : '点击选择提现金额' }}
            </span>
            <i class="iconfont yw-16_shixinxiangxia"></i>
          </div>
          <ul :class="`${$style.options} ${selected && $style.active}`" v-if="!withdrawMethod || receive_info.version == 2">
            <li v-for="(item, index) in options" :key="index" @click="selectMoney(item)">
              <span>{{ item.label }}</span>
            </li>
          </ul>
          <ul :class="`${$style.options} ${selected && $style.active}`" v-else>
            <li v-for="(item, index) in flashOptions" :key="index" @click="selectMoney(item)">
              <span>{{ item.label }}</span>
            </li>
          </ul>
          <span :class="`${$style.hint} ${hintShow && $style.active}`">您的余额不足！！</span>
        </div>
      </div>
      <div :class="$style.method">
        <h3>提现方式</h3>
        <ul :class="$style.options">
          <li
            v-for="(item, index) in methodOptions"
            :key="index"
            @click="selectMethods(item)"
            :class="item.value === currentMethod.value ? $style.active : ''"
          >
            <img :src="item.icon" alt="" v-if="item.icon" />
            <span>{{ item.label }}</span>
          </li>
        </ul>
        <p :class="$style.hint">* 微信领取红包需要绑定游戏账号以及关注公众号哦！</p>
      </div>
      <button :class="$style.withdraw" @click="withDraw">立即使用</button>
      <p :class="$style.strategy" @click="$emit('setPage', 'step')">提现攻略 ></p>
      <p :class="$style.statement" @click="statementVisible = true">免责声明 ></p>
    </div>
    <!-- 提现认证 -->
    <AntiIndulged v-if="bindShow" @close="bindShow = false" @success="bindShow = false" :type="currentWithDrawType"></AntiIndulged>
    <Statement v-if="statementVisible" @close="statementVisible = false"></Statement>
    <div :class="$style.popup" v-if="withDrawSuccess">
      <div :class="$style.content">
        <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="withDrawSuccess = false"></i>
        <p>您的提现申请已提交成功</p>
        <p>请前往{{ this.currentWithDrawType == 1 ? '微信公众号' : '支付宝' }}查收，红包会在48小时内尽快发放</p>
        <p :class="$style.sm">点击<span :class="$style.link" @click="toStep">提现攻略 ></span>，可查看详细领取步骤</p>
      </div>
    </div>
    <div :class="[$style.popup, $style.bindAccount]" v-if="bindVisible">
      <div :class="$style.content">
        <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="bindVisible = false"></i>
        <p style="text-align: center">绑定说明</p>
        <p>1、复制下方绑定码</p>
        <p>2、点击“前往微信”，关注<span>星娱福利中心</span>微信公众号，选择“福利中心”-“红包提现”进行绑定</p>
        <p :class="$style.sm">注意：</p>
        <p :class="$style.sm">1、请勿将绑定码告知他人</p>
        <p :class="$style.sm">2、账号绑定微信号后无法更改，请确定绑定正确的微信号</p>
        <div :class="$style.bindContent">
          <span>绑定码：</span>
          <span :class="$style.code">{{ bindUserAuthCode }}</span>
          <button class="copy-btn" :data-clipboard-text="bindUserAuthCode">复制</button>
        </div>
        <button :class="$style.redirectWechat" @click="jump">前往微信</button>
      </div>
    </div>
  </div>
</template>

<script>
import { sort_ASCII } from '@/libs/utils';
import { mapState } from 'vuex';
import {
  getWalletInfo,
  getWalletInfoV2,
  withDraw,
  withDrawV2,
  getWithdrawOptions,
  directRecharge,
  getWithdrawOptionsV2,
  getWithdrawOptionsV3,
  getTempId,
  checkALiBindResult,
} from '@/api/activity';
import AntiIndulged from './AntiIndulged';
import Statement from './Statement';
import { gameOpenDownloads, backGameFromliPa } from '@/bridge/AppJsBridge';
import ClipboardJS from 'clipboard';

// 是否开启直充类型
const DIRECT_RECHARGE_TYPE = {
  NO: 1, // 否
  ALL: 2, // 不仅限直充
  DIRECT: 3, // 仅限直充
};

// 充值方式
const RECHARGE_TYPE = {
  DIRECT: 0, // 直充
  WECHAT: 1, // 微信
  ALIPAY: 2, // 支付宝
};

export default {
  name: '',
  data() {
    return {
      balance: 0.0,
      flash_money: 0.0,
      options: [],
      flashOptions: [],
      methodOptions: [
        { label: '支付宝', value: RECHARGE_TYPE.ALIPAY, icon: `${this.$cdnLink}/common/zfb.png` },
        { label: '微信', value: RECHARGE_TYPE.WECHAT, icon: `${this.$cdnLink}/common/wx.png` },
      ],
      withDrawAccount: null,
      withDrawFlag: false,
      selected: false,
      hintShow: false,
      currentMethod: {
        label: '微信',
        value: RECHARGE_TYPE.WECHAT,
        icon: `${this.$cdnLink}/common/wx.png`,
      },
      direct_recharge: '',
      direct_rate: '',
      bindShow: false, // 提现认证弹窗
      statementVisible: false,
      withDrawSuccess: false,
      withdrawType: '', // 提现类型 1.等级 2.充值 3.高级
      withdrawMethod: 0, // 提现方式 默认0 0.普通红包 1.闪电提现
      bindVisible: false, // 未绑定公众号弹框提示
      bindUserAuthCode: '', // 用户临时绑定码
      retryTime: 0,
      currentWithDrawType: '',
      withdrawStep: 0, // 提现步骤 0.选择红包类型 1.选择提现方式 2.选择提现金额
      levelBalance: {
        balance: 0.0,
        flash_money: 0.0,
      },
      payBalance: {
        balance: 0.0,
        flash_money: 0.0,
      },
      advancedBalance: {
        balance: 0.0,
        flash_money: 0.0
      },
      allBalance: 0,
    };
  },
  async mounted() {
    let receive_info = this.$store.state.redEnvelope.receive_info;
    if (receive_info && receive_info.version == 1) {
      this.withdrawStep = 1;
      this.getWithdrawOptions()
    }
    this.getBalance();
    this.handleSpecialMoney();
    this.copyInit();
    backGameFromliPa(() => {
      this.checkALiBind();
    });
  },
  watch: {
    withdrawStep(val) {
      if (val != 2) {
        this.currentMethod = {
          label: '微信',
          value: RECHARGE_TYPE.WECHAT,
          icon: `${this.$cdnLink}/common/wx.png`,
        }
        this.selected = false;
        this.withDrawAccount = null;
        this.hintShow = false;
      }
    }
  },
  computed: {
    ...mapState({
      receive_info: (state) => state.redEnvelope.receive_info,
      appkey: (state) => state.user.appkey,
      user_id: (state) => state.user.user_id,
      user_name: (state) => state.user.username,
      tel_status: (state) => state.user.tel_status,
      role: (state) => state.redEnvelope.role,
    }),
    currentBalance() {
      if (this.withdrawType == 1) {
        return this.levelBalance
      } else if (this.withdrawType == 2) {
        return this.payBalance
      } else if (this.withdrawType == 3) {
        return this.advancedBalance
      } else {
        return {}
      }
    }
  },
  methods: {
    copyInit() {
      this.copy = new ClipboardJS('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
      });
    },
    // 获取钱包余额
    async getBalance() {
      this.levelBalance = {
        balance: 0.0,
        flash_money: 0.0,
      }
      this.payBalance = {
        balance: 0.0,
        flash_money: 0.0,
      },
      this.advancedBalance = {
        balance: 0.0,
        flash_money: 0.0
      }
      this.allBalance = 0
      console.log(324)
      let r = null;
      if (this.receive_info.version == 2) {
        r = await getWalletInfoV2({
          user_id: this.user_id,
          role_id: this.role.role_id,
        });
        this.allBalance = 0;
        r.content.wallet_list.map((item) => {
          this.allBalance = this.allBalance + item.money;
          if (item.sub_rule_type == 1) {
            this.levelBalance.show  = true;
            if (item.wallet_type == 1) {
              this.levelBalance.balance = this.levelBalance.balance + item.money;
              this.levelBalance.balanceShow = true;
            } else {
              this.levelBalance.flash_money = this.levelBalance.flash_money + item.money;
              this.levelBalance.flashMoneyShow = true;
            }
          } else if (item.sub_rule_type == 2) {
            this.payBalance.show  = true;
            if (item.wallet_type == 1) {
              this.payBalance.balance = this.payBalance.balance + item.money;
              this.payBalance.balanceShow = true;
            } else {
              this.payBalance.flash_money = this.payBalance.flash_money + item.money;
              this.payBalance.flashMoneyShow = true;
            }
          } else if (item.sub_rule_type == 3) {
            this.advancedBalance.show  = true;
            if (item.wallet_type == 1) {
              this.advancedBalance.balance = this.advancedBalance.balance + item.money;
              this.advancedBalance.balanceShow  = true;
            } else {
              this.advancedBalance.flash_money = this.advancedBalance.flash_money + item.money;
              this.advancedBalance.flashMoneyShow  = true;
            }
          }
        });
        this.allBalance = this.allBalance.toFixed(2);
      } else {
        r = await getWalletInfo({
          user_id: this.user_id,
          appkey: this.appkey,
        });
        this.balance = r.content.money || 0;
        this.flash_money = r.content.flash_money || 0;
        this.direct_recharge = r.content.direct_recharge;
        this.direct_rate = r.content.direct_rate;
        this.handleDirectRecharge();
      }
      if (this.withdrawType) this.resetBalance();
    },
    // 1.等级红包 2.充值红包 3.高级红包
    selectWithdrawType(type) {
      this.$emit('setWalletType', type);
      this.withdrawType = type;
      this.resetBalance();
      this.withdrawStep = 1;
    },
    resetBalance() {
      if (this.withdrawType == 1) {
        this.balance = this.levelBalance.balance;
        this.flash_money = this.levelBalance.flash_money;
      } else if (this.withdrawType == 2) {
        this.balance = this.payBalance.balance;
        this.flash_money = this.payBalance.flash_money;
      } else if (this.withdrawType == 3) {
        this.balance = this.advancedBalance.balance;
        this.flash_money = this.advancedBalance.flash_money;
      }
    },
    // 0 普通红包 1 闪电提现
    selectWithdrawMethod(method) {
      this.$emit('setWalletMthod', method);
      this.withdrawMethod = method;
      this.withdrawStep = 2;
      this.getWithdrawOptions();
    },
    setWithDrawStep(type, method) {
      this.withdrawType = type;
      this.withdrawMethod = method;
      this.withdrawStep = 2;
      this.getWithdrawOptions();
    },
    handleDirectRecharge() {
      if (this.receive_info.version == 2) {
        this.methodOptions = [
          { label: '支付宝', value: RECHARGE_TYPE.ALIPAY, icon: `${this.$cdnLink}/common/zfb.png` },
          { label: '微信', value: RECHARGE_TYPE.WECHAT, icon: `${this.$cdnLink}/common/wx.png` },
        ];
        this.currentMethod = this.methodOptions[0];
      } else {
        if (this.direct_recharge === DIRECT_RECHARGE_TYPE.ALL) {
          this.methodOptions = [
            { label: '微信提现', value: RECHARGE_TYPE.WECHAT },
            { label: '支付宝提现', value: RECHARGE_TYPE.ALIPAY },
            {
              label: `游戏直充`,
              value: RECHARGE_TYPE.DIRECT,
              hint: this.direct_rate != 1 ? `（多享${(this.direct_rate - 1).toFixed(2) * 100}%返利）` : '',
            },
          ];
        } else if (this.direct_recharge === DIRECT_RECHARGE_TYPE.DIRECT) {
          this.methodOptions = [
            {
              label: `游戏直充`,
              value: RECHARGE_TYPE.DIRECT,
              hint: this.direct_rate != 1 ? `（多享${(this.direct_rate - 1).toFixed(2) * 100}%返利）` : '',
            },
          ];
        } else {
          this.methodOptions = [
            { label: '微信提现', value: RECHARGE_TYPE.WECHAT, icon: `${this.$cdnLink}/common/wx.png` },
            { label: '支付宝提现', value: RECHARGE_TYPE.ALIPAY, icon: `${this.$cdnLink}/common/zfb.png` },
          ];
        }
        this.currentMethod = this.methodOptions[0];
      }
    },
    // 针对特殊包处理提现金额列表
    async handleSpecialMoney() {
      const { appkey } = this.$store.state.user;
      const specialPacket = ['100004900'];
      if (specialPacket.includes(appkey)) {
        this.options = [
          { label: '3元', value: '3' },
          { label: '5元', value: '5' },
          { label: '10元', value: '10' },
          // { label: "20元", value: "20" },
          { label: '50元', value: '50' },
          { label: '100元', value: '100' },
        ];
      }
    },
    back() {
      if (this.withdrawStep != 0 && this.receive_info.version == 2) {
        this.withdrawStep = this.withdrawStep - 1;
        return;
      } 
      this.$emit('setPage', 'receive');
    },
    selectMoney(item) {
      const { value } = item;
      this.hintShow = this.withdrawMethod === 1 ? Number(value) > Number(this.flash_money) : Number(value) > Number(this.balance);
      this.withDrawAccount = item;
      this.selected = false;
    },
    selectMethods(item) {
      this.currentMethod = item;
    },
    toRecord() {
      this.$emit('setPage', 'record');
    },
    withDraw() {
      if (this.hintShow) {
        this.$toast('您的余额不足，无法提现');
        return;
      }
      if (!this.withDrawAccount) {
        this.$toast('请选择提现金额');
        return;
      }

      // 防止重复点击
      if (this.withDrawFlag) return;
      this.withDrawFlag = true;
      this.currentWithDrawType = this.currentMethod.value;
      if (this.currentMethod.value === RECHARGE_TYPE.DIRECT) {
        this.directRecharge();
      } else {
        this.commomWithdraw();
      }
    },
    async directRecharge() {
      try {
        await directRecharge({
          user_id: this.user_id,
          appkey: this.appkey,
          money: this.withDrawAccount.value,
          role_id: this.role.role_id,
          role_name: this.role.role_name,
          server_num: this.role.server_num,
          server_name: this.role.server_name,
        });
        this.$toast('申请提交成功');
      } catch (error) {
        error.msg && this.$toast(error.msg);
      }
      this.withDrawFlag = false;
    },
    async commomWithdraw() {
      try {
        let r = null;
        if (this.receive_info.version == 2) {
          r = await withDrawV2({
            user_id: this.user_id,
            role_id: this.role.role_id,
            sub_rule_type: this.withdrawType,
            wallet_type: this.withdrawMethod ? 2 : 1,
            money: this.withDrawAccount.value,
            type: this.currentMethod.value,
            server: this.role.server_num,
            role_name: this.role.role_name,
            server_name: this.role.server_name,
            appkey: this.appkey,
          });
        } else {
          r = await withDraw({
            user_id: this.user_id,
            appkey: this.appkey,
            money: this.withDrawAccount.value,
            flash: this.withdrawMethod === 1 ? 1 : 0,
            type: this.currentMethod.value,
          });
        }
        if (r.content.status == -1) {
          // 实名验证
          this.bindShow = true;
          this.withDrawFlag = false;
          return;
        }
        if (r.content.status == -2) {
          this.withDrawFlag = false;
          gameOpenDownloads({
            gameUrl: r.content.alipay_auth_uri,
          });
          return;
        }
        if (r.content.status == 4) {
          // 获取临时用户绑定码
          this.bindVisible = true;
          this.withDrawFlag = false;
          this.getAuthCode();
          return;
        }
        this.withDrawSuccess = true;
        this.getBalance();
        this.getWithdrawOptions();
        this.withDrawAccount = null;
        // this.$toast('申请提交成功');
        // setTimeout(() => {
        //   this.$emit('setPage', 'step');
        // }, 1500);
      } catch (error) {}
      this.withDrawFlag = false;
    },
    async getWithdrawOptions() {
      let r = null;
      if (this.receive_info.version == 2) {
        r = await getWithdrawOptionsV3({
          user_id: this.user_id,
          role_id: this.role.role_id,
          sub_rule_type: this.withdrawType,
          wallet_type: this.withdrawMethod ? 2 : 1,
        });
      } else {
        r = await getWithdrawOptionsV2({
          user_id: this.user_id,
          appkey: this.appkey,
        });
      }
      // V2版本
      if (r.content.option_list && r.content.option_list.length) {
        this.options = r.content.option_list.map((item) => {
          return {
            label: item.type == 2 ? `${item.money}元（剩余可提现次数：${item.count}）` : `${item.money}元`,
            value: item.money,
          };
        });
      } else {
        this.options = []
      }

      // v1 版本后续废弃
      if (r.content.normal_options && r.content.normal_options.length) {
        this.options = r.content.normal_options.map((item) => {
          return {
            label: item.type == 2 ? `${item.money}元（剩余可提现次数：${item.count}）` : `${item.money}元`,
            value: item.money,
          };
        });
      }
      if (r.content.flash_options && r.content.flash_options.length) {
        this.flashOptions = r.content.flash_options.map((item) => {
          return {
            label: item.type == 2 ? `${item.money}元（剩余可提现次数：${item.count}）` : `${item.money}元`,
            value: item.money,
          };
        });
      }
    },
    jump() {
      gameOpenDownloads({
        gameUrl: this.receive_info.jump_link,
      });
    },
    toStep() {
      this.$emit('setPage', 'step');
    },
    async getAuthCode() {
      const access_token = this.$getStorage('access_token');

      const r = await getTempId({
        user_id: this.user_id,
        access_token: access_token,
        appkey: this.appkey,
      });
      this.bindUserAuthCode = r.content.temp_id;
    },
    // 检查支付宝绑定接口
    async checkALiBind() {
      this.withDrawFlag = false;
      try {
        await checkALiBindResult({ user_id: this.user_id });
        this.$toast('绑定成功', 3000);
      } catch (error) {
        if (error.ret == 598 && this.retryTime < 5) {
          this.retryTime = this.retryTime + 1;
          setTimeout(this.checkALiBind, 2000);
        } else {
          this.$toast(error.msg, 3000);
        }
      }
    },
  },
  components: {
    AntiIndulged,
    Statement,
  },
};
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.resetBtn {
  background-color: transparent;
  border: none;
  outline: none;
}
.btnActive {
  &:active {
    -webkit-filter: brightness(105%);
    filter: brightness(105%);
  }
}
.touchNone {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.wallet {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #ffffff;
  border-radius: 10px;
  overflow: auto;
  padding: 6px;
  box-sizing: border-box;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    position: relative;
    font-size: $font-lg;
    color: #424242;
    text-align: center;
    margin-bottom: 12px;
    > .back {
      position: absolute;
      left: 0;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 5px {
        top: 0;
        left: 0;
      }
    }
  }
  .redEnvelopeType {
    .typeList {
      > li {
        height: 46px;
        background: #fafafa;
        border-radius: 2.5px;
        margin-bottom: 7px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        > div {
          display: flex;
          align-items: center;
          > img {
            width: 36px;
            height: 36px;
            margin-right: 7px;
          }
          .typeName {
            font-size: 12px;
            font-weight: 700;
            margin-bottom: 5px;
          }
          .typeBalance {
            font-size: 8px;
            font-weight: 500;
            color: #959595;
            > span {
              color: #ff5b58;
            }
          }
        }
        > button {
          width: 60px;
          height: 22.5px;
          background: #ff5b58;
          border-radius: 11.5px;
          font-size: 8px;
          text-align: center;
          color: #ffffff;
          line-height: 22.5px;
          border: none;
          outline: none;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
  }
  .record {
    margin-top: 20px;
    text-align: right;
    color: #ff5b58;
    font-size: $font-nm;
    :global {
      .yw-xiangyou {
        font-size: 10px;
      }
    }
  }
  .selectMethods {
    .typeItem {
      padding: 0 10px;
      background: #fafafa;
      border-radius: 2.5px;
      height: 46px;
      display: flex;
      align-items: center;
      font-size: 12px;
      position: relative;
      margin: 5px auto;
      > img {
        width: 38px;
        height: 38px;
        margin-right: 6px;
      }
      .withdraw {
        position: absolute;
        right: 10px;
        margin: 0;
        width: 80px;
        height: 25px;
        font-size: 11px;
        line-height: 24.5px;
      }
      .balance {
        > p:nth-child(1) {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 5px;
        }
        > p:nth-child(2) {
          color: #959595;
          text-align: left;
          margin-top: 5px;
          font-size: 8px;
          > span {
            color: #ff362e;
          }
        }
      }
    }
  }
  .info {
    width: 100%;
    height: 76px;
    border-radius: 4px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/wallet_back.png') no-repeat;
    background-size: 100% 100%;
    font-size: $font-nm;
    color: #ffffff;
    box-sizing: border-box;
    padding: {
      bottom: 19px;
      left: 22px;
      right: 32px;
    }
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 20px;
    margin-bottom: 17px;
    :global {
      .yw-xiangyou {
        font-size: $font-nm;
      }
    }
    .account {
      margin-bottom: 15px;
    }
  }
  .method,
  .price {
    > h3 {
      color: #000000;
      font-size: $font-nm;
      padding-left: 4px;
      margin-bottom: 12px;
    }
  }
  .method {
    font-size: 0;
    margin-bottom: 15px;
    > h3 {
      display: inline-block;
    }
    .options {
      font-size: 12px;
      display: flex;
      > li {
        margin-top: 4px;
        border: 1px solid #c1c1c1;
        padding: 10px 14px;
        border-radius: 4px;
        margin-right: 12px;
        display: flex;
        align-items: center;
        width: 120px;
        > span {
          font-weight: 600;
        }
        > img {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
        &.active {
          color: #ff0000;
          border: 1px solid #ff0000;
        }
      }
    }
    > .hint {
      color: #e85333;
      font-size: $font-sm;
      margin-top: 6px;
      margin-left: 1px;
    }
  }
  .balanceWithdraw {
    padding: 10px;
  }
  .price {
    display: flex;
    align-items: center;
    font-size: 0;
    margin-top: 20px;
    margin-bottom: 40px;
    > h3 {
      margin-bottom: 0;
    }
    .select {
      @extend .touchNone;
      display: flex;
      align-items: center;
      position: relative;
      margin-left: 5px;
      .exhibition {
        width: 183px;
        border-bottom: 1px solid #cccccc;
        color: #707070;
        font-size: $font-nm;
        padding: 0px 9px 4px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        :global {
          .yw-16_shixinxiangxia {
            color: #a6a6a6;
            font-size: 12px;
          }
        }
      }
      .options {
        position: absolute;
        left: 0.5%;
        width: 180px;
        top: 22px;
        color: #707070;
        overflow-y: auto;
        box-shadow: 0px 2px 8px 0 rgb(235, 233, 233);
        box-sizing: border-box;
        background: #ffffff;
        // padding: .1rem 0;
        height: 100px;
        transform: translateY(-50%) scaleY(0);
        // transform: scale3d(1, 0, 1);
        transition: all 0.2s ease-in;
        &.active {
          transform: translateY(0) scaleY(1);
        }
        > li {
          padding: 7px;
          font-size: $font-nm;
          &:active {
            background: #f4f4f4;
          }
        }
      }
      > .hint {
        display: none;
        color: #e85333;
        font-size: $font-sm;
        // display: inline-block;
        margin-left: 6px;
        &.active {
          display: inline-block;
        }
      }
    }
  }
  .withdraw {
    @extend .resetBtn;
    @extend .btnActive;
    background: #ff5b58;
    color: #ffffff;
    display: block;
    width: 200px;
    height: 33.5px;
    line-height: 34px;
    font-size: 13px;
    border-radius: 33px;
    margin: auto {
      top: 20px;
    }
  }
  .strategy {
    text-align: center;
    color: #ff5b58;
    font-size: 12px;
    margin-top: 20px;
  }
  .statement {
    text-align: right;
    color: #ff5b58;
    font-size: 12px;
    margin-top: 30px;
    text-decoration: underline;
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    .content {
      width: 278px;
      height: 186px;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/fuli/back.png');
      background-size: 100% 100%;
      font-size: 14px;
      text-align: left;
      padding: 40px 10px 0;
      box-sizing: border-box;
      .fanhui {
        position: absolute;
        top: 8px;
        right: 8px;
        color: #ffffff;
      }
      > p {
        line-height: 18px;
        > span {
          color: #ff5b58;
        }
      }
      > p:nth-child(1),
      > p:nth-child(2) {
        font-weight: 700;
        > span {
          font-weight: 700;
        }
      }
      .link {
        color: #1505fe;
        text-decoration: underline;
      }
      .sm {
        font-size: 12px;
      }
      .hint {
        margin-top: 15px;
      }
    }
    &.bindAccount {
      .content {
        width: 328px;
        height: 256px;
        padding: 20px 10px 0;
        > p:nth-child(1),
        > p:nth-child(2) {
          font-size: 16px;
          margin-bottom: 5px;
          font-weight: 700;
          > span {
            font-weight: 700;
          }
        }
      }
      .bindContent {
        display: flex;
        font-size: 14px;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        .code {
          width: 100px;
          white-space: nowrap; //禁止换行
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 5px;
          overflow: hidden;
        }
        > button {
          @extend .resetBtn;
          @extend .btnActive;
          background: #ff5b58;
          font-size: 12px;
          padding: 4px 8px;
          color: #ffffff;
          display: block;
          border-radius: 4px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .redirectWechat {
        @extend .withdraw;
        margin-top: 15px;
        width: 160px;
        height: 28px;
        font-size: 12px;
        line-height: 27.5px;
      }
    }
  }
}
</style>
